
// const tabErrors: Map<string, string> = new Map();

export function init(id: string) {
  const form           = document.getElementById(id) as HTMLFormElement;
  const formErrorState = document.getElementById('form-error-state') as HTMLElement;

    form.addEventListener('hasError', event => {
      formErrorState.classList.add('has-errors');
    });

    form.addEventListener('noError', event => {
      formErrorState.classList.remove('has-errors');
    });

}
